import { Box, Button, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Redirect } from "../../../utils/Redirect";
import CustomColor from "../../../utils/overrides/color";

import React from "react";

export default function ExpiredToken() {
  const location = useLocation();
  const refresh = () => {
    Redirect({ to: location.pathname });
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box>
        <img src="/session-expired.png" alt="Logo" width={194} height={166} />
      </Box>
      <Typography
        variant="h4"
        sx={{
          marginTop: "40px",
          fontWeight: 600,
          fontSize: "32px",
          lineHeight: "40px",
          color: "#111315",
          fontFamily: "Inter, sans-serif",
        }}
      >
        Phiên đã hết hạn
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginTop: "12px",
          color: "#323741",
          fontWeight: 400,
          fontSize: "16px",
          lineHeight: "24px",
          fontFamily: "Inter, sans-serif",
        }}
      >
        Vui lòng đăng nhập lại để làm mới phiên của bạn.
      </Typography>
      <Button
        sx={{
          marginTop: "32px",
          fontWeight: 600,
          fontSize: "14px",
          lineHeight: "20px",
          padding: "14px 24px",
          borderRadius: "12px",
          fontFamily: "Inter, sans-serif",
        }}
        variant="contained"
        onClick={refresh}
      >
        Làm mới
      </Button>
    </Box>
  );
}
